import { Component, ViewEncapsulation, input } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';

let nextId = 0;

@Component({
  selector: 'ds-callout-block',
  templateUrl: './callout-block.html',
  styleUrl: './callout-block.scss',
  encapsulation: ViewEncapsulation.None,
  imports: [NgOptimizedImage],
})
export class CalloutBlockComponent {
  readonly color = input<string>('orange');
  readonly heading = input<string>('');
  readonly body = input<string>('');
  readonly label = input<string>('');
  readonly imageSrc = input<string>('');
  readonly imageAlt = input<string>('');
  readonly imageWidth = input<number>(0);
  readonly imageHeight = input<number>(0);

  /**
   * Stable per-instance DOM id for the callout heading. Quick-99: the heading
   * id is referenced by `[attr.aria-labelledby]` on the `<aside>` landmark when
   * the optional `label` Strapi field is empty — closes axe-core
   * `landmark-unique` by giving each unlabelled callout a distinct accessible
   * name from its inner heading text. Pattern mirrors `faq-item.ts` `panelId`.
   */
  readonly headingId = `callout-heading-${nextId++}`;

  getBorderColor(): string {
    switch (this.color()) {
      case 'orange':
        return 'var(--color-orange-400)';
      case 'blue':
        return 'var(--color-blue-600)';
      case 'dark-blue':
        return 'var(--accent-dark-blue, var(--color-dark-blue-950))';
      default:
        return this.color();
    }
  }
}
